import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 43,
    height: 17,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(26px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#09C491",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#476b6b",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 15,
    height: 15,
  },
  track: {
    borderRadius: 26 / 2,
    backgroundColor: "rgba(68, 91, 110, 0.3)",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}));

const SwitchComponent = ({ checked, handleClick, labelText }) => {
  const classes = useStyles();

  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      onClick={handleClick}
      checked={checked}
      inputProps={{
        "aria-label": labelText,
      }}
    />
  );
};

export default SwitchComponent;
